var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 13 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.352 5.69.87 8.727c.047.369 1.805 1.581 4.349 1.583 2.546-.002 4.303-1.214 4.35-1.583l.87-8.727c-1.329.754-3.316 1.11-5.22 1.11-1.902 0-3.89-.356-5.219-1.11Zm7.72-4.482-.678-.76C8.132.067 7.848 0 7.294 0H5.85c-.553 0-.838.069-1.1.447l-.677.761c-2.03.36-3.5 1.312-3.5 2.015v.136C.571 4.597 3.257 5.6 6.57 5.6c3.314 0 6-1.003 6-2.24v-.137c0-.703-1.47-1.656-3.5-2.015Zm-.867 2.264L7.36 2.4H5.782l-.844 1.072H3.596s1.47-1.777 1.667-2.018c.15-.184.303-.254.502-.254h1.613c.2 0 .353.07.503.254.195.241 1.666 2.018 1.666 2.018H8.205Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.13ac08704425c55797121e99adebe7bc.svg";
export { ForwardRef as ReactComponent };